/**
 * Import Lib & assets
 */

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

import { isOdd } from "helpers/tools/maths";

/**
 * import components
 */

import { Table__cell } from "components/table/table";
import Content__tooltip from "../../content/tooltip/content__tooltip";

/**
 * styled components
 */

const Row = styled.div`
  display: flex;
  flex-direction: row;
  ${({ odd }) =>
    odd &&
    `
      background-color: ${t.color.greyGallery};
    `}

  ${t.mixins.sm(`
    position: relative;
    flex-direction: column;
    align-items: flex-start;
    display: inline-flex;
  `)}
`;
const HiddenCell = styled(Table__cell)`
  position: relative;
  visibility: hidden;

  ${t.mixins.sm(`
    position: relative;
    display: none;
  `)}
`;
const Wrapper = styled.div`
  ${t.mixins.flex({ align: "stretch" })}
`;

/**
 * row component is..
 */

const Table__row = ({ data, title, content, index, tooltip }) => {
  let odd = isOdd(index);
  return (
    <Row odd={odd}>
      <Table__cell first odd={odd} index={index}>
        {title}
        {tooltip && <Content__tooltip content={tooltip} size={14} />}
      </Table__cell>
      <HiddenCell first odd={odd} index={index}>
        {title}
        {tooltip && <Content__tooltip content={tooltip} size={14} />}
      </HiddenCell>
      <Wrapper>
        {data.map((item, itemIndex) => {
          const value = item.specs[content];
          const colOdd = isOdd(itemIndex);
          return (
            <Table__cell key={item.id} odd={odd} colOdd={colOdd}>
              {value}
            </Table__cell>
          );
        })}
      </Wrapper>
    </Row>
  );
};

export default Table__row;

Table__row.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Table__row.defaultProps = {
  style: {},
};

/*
    import Table__row from 'components/table/row/table__row'
    <Table__row />
  */
